import Vue from 'vue'
import VueRouter from '@node_modules/vue-router'

Vue.use(VueRouter)


import TabsCmp from '@components/tabs_cmp'
import InitiativesCmp from '@components/initiatives_cmp'
import TrainingCmp from '@components/training_cmp'
import NetworkCmp from '@components/network_cmp'


const router = new VueRouter({
  //mode: 'history',
  routes: [
    { 
      path: '/',
      redirect: {
        name: 'network'
      }
    },
    { 
      path: '/network', 
      name: 'network',
      component: NetworkCmp
    },
    { 
      path: '/initiatives', 
      name: 'initiatives',
      component: InitiativesCmp
    },
    { 
      path: '/training', 
      name: 'training',
      component: TrainingCmp
    },
    { 
      path: '/companies', 
      name: 'companies',
      beforeEnter: function(to, from, next){}
    }
  ]
})

export default router